export enum GalleryColumns {
  Model = 'model',
  Tags = 'tags',
  CreatedBy = 'created-by',
  UpdatedBy = 'updated-by',
  Actions = 'actions'
}
